<template>
  <li class="inline-flex list-none" :tabindex="null" :aria-disabled="true">
    <span
      class="text-xs text-slate-600 dark:text-slate-100 mt-1 font-medium w-full block text-left rtl:text-right whitespace-nowrap p-2"
    >
      {{ title }}
    </span>
    <slot />
  </li>
</template>
<script>
export default {
  componentName: 'WootDropdownMenu',
  props: {
    title: {
      type: String,
      default: '',
    },
    className: {
      type: String,
      default: '',
    }
  },
};
</script>
<style lang="scss" scoped>
.dropdown-menu--header {
  display: inline-flex;
  list-style: none;

  .title {
    width: 100%;
    display: block;
    text-align: left;
    white-space: nowrap;
    padding: var(--space-small) var(--space-small);
    margin-top: var(--space-smaller);
    font-size: var(--font-size-mini);
    color: var(--s-600);
    font-weight: var(--font-weight-medium);
    border-radius: var(--border-radius-normal);
  }

  .question-dropdown, .filter-dropdown {
    display: flex;
    flex-wrap: wrap;
    
    white-space: inherit;
    height: auto;
  }

  .question-dropdown {
    max-width: 536px;
  }

  .filter-dropdown {
    max-width: 300px;
  }
}
.primary {
  color: var(--w-500) !important;
  font-weight: bold !important;
}
</style>
